<template>
  <nav v-if="isAuth" class="uk-navbar-container uk-margin" uk-navbar>
      <div class="uk-navbar-left">
        <a class="uk-navbar-item uk-logo" href="#">
        <img src="https://www.resnetworld.com/wp-content/themes/resnetworld/images/resnet-logo.png" alt="" v-bind:style="{width:'100px'}">
        </a>
      </div>
      <div class="uk-navbar-right">
        <ul class="uk-navbar-nav">
            <li class="nav-item"><router-link :to="{name:'dashboard'}"><span uk-icon="icon: cog" class="uk-margin-small-right uk-icon"></span> Settings</router-link></li>
            <li class="nav-item"><a  @click="_doLogout()"><span uk-icon="icon: sign-out" class="uk-margin-small-right uk-icon"></span> Log Out</a></li>
        </ul>
      </div>
  </nav>
</template>

<script>
export default {
  name: "navigation-bar",
  data: () => ({
    isAuth: false
  }),
  created(){
    this._checkAuth();
  },
  watch: {
    $route: function(from, to) {
      this._checkAuth();
    }
  },
  methods: {
    _doLogout() {
      localStorage.clear();
      this.$router.push({ name: "login" });
    },
    _checkAuth() {
      this.isAuth = (localStorage.getItem("isAuth")) ? true : false;
    }
  }
};
</script>
